const showMore = '[data-show-more=""]'
const showMoreBtn = '[data-show-more="btn"]'
const showMoreBtnTxt = '[data-show-more="btn-txt"]'
const mainScrollContainer = '.y-main__inner' // main container with scroll (default: root)
const style = `
<style>
[data-show-more=""] {
    transition: height var(--sm_trs, 500ms);
    position: relative;
}

[data-show-more=""]:not(.is_open)::after {
    content: "";
    width: 100%;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(to bottom, rgba(var(--sm_rgba, 255,255,255), 0.2) 0%, var(--sm_bgc, #fff) 127%);
}

.show-more-nav {
    display: flex;
    flex-wrap: wrap;
    margin-top: var(--sm_nav_mt ,10px)
}

.show-more-nav.is_center {
    justify-content: center;
}
.show-more-nav .y-btn.is_arrow.is_open {
	transform: scale(1, -1);
}
</style>
`
$(window).on('load', function () {

	$(root).append(style)

	$(showMore).each(function () {

		const delay = $(this).data('delay') ?? 1000
		const firstTxt = $(this).data('first-txt')
		const nextTxt = $(this).data('next-txt')
		const visibleHeight = $(this).data('visible-height') || 'auto'
		const blockClass = $(this).data('bock-class')
		const icnTemplate = `<div class="show-more-nav is_center ${ blockClass }__show-more-nav">
								<button type="button" data-show-more="btn" class="y-btn is_arrow ${ blockClass }__btn-show-more">
									<span class="y-btn__icn">
										<svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 0C114.88 0 0 114.88 0 256s114.88 256 256 256 256-114.88 256-256S397.12 0 256 0zm0 490.667c-129.387 0-234.667-105.28-234.667-234.667S126.613 21.333 256 21.333 490.667 126.613 490.667 256 385.387 490.667 256 490.667z"/><path d="M365.76 280.533l-99.093 99.093V107.093c0-5.333-3.84-10.133-9.067-10.88-6.613-.96-12.267 4.16-12.267 10.56v272.96l-99.093-99.2c-4.267-4.053-10.987-3.947-15.04.213a10.763 10.763 0 000 14.827l117.333 117.333a10.623 10.623 0 0015.04 0l117.333-117.333c4.053-4.267 3.947-10.987-.213-15.04-4.16-3.946-10.773-3.946-14.933 0z"/></svg>
									</span>
								</button>
							 </div>`;
		const txtTemplate = `<div class="show-more-nav ${ blockClass }__show-more-nav">
								<button type="button" data-show-more="btn" class="y-btn ${ blockClass }__btn-show-more">
									<span class="y-btn__txt" data-show-more="btn-txt">${ firstTxt }</span>
									<span class="y-btn__icn">
										<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 7.09375L11.0083 2.08542L9.83083 0.90625L6 4.73958L2.17 0.90625L0.991669 2.08458L6 7.09375Z" /></svg>
									</span>
								</button>
							 </div>`;
		const template = firstTxt ? txtTemplate : icnTemplate
		const showMoreHeight = $(this).height()

		if (showMoreHeight > visibleHeight) {
			setTimeout(() => {
				$(this).css({
					'overflow': 'hidden',
					'padding-right': '7px',
					'margin-right': '-7px',
					'height': `${ visibleHeight }px`
				}).removeClass('is_open').after(template);
			}, delay)

			$(document).off('click').on('click', showMoreBtn, function () {
               	const $content = $(this).parent().prev()

				if ($(this).hasClass('is_open')) {
					const $blockOffset = $content.parent()[0].offsetTop - 50
					$(this).removeClass('is_open')
					$(showMoreBtnTxt, this).text(firstTxt)
					$content.removeClass('is_open').height(visibleHeight)
					$(mainScrollContainer).animate({ scrollTop: $blockOffset }, 150)
				} else {
					$(this).addClass('is_open')
					$(showMoreBtnTxt, this).text(nextTxt)
					$content.addClass('is_open').height($content[0].scrollHeight)
				}
			})
		} else {
			$(showMore).addClass('is_open')
		}
	})

	$(this).resize(() => {
		$(showMore).each(function () {
			const firstTxt = $(this).data('first-txt')
			const visibleHeight = $(this).data('visible-height') || 'auto'
			const showMoreNav = $(this).next()
			const showMoreHeight = $(this).height()

			if (showMoreHeight > visibleHeight) {
				$(this).css('height', `${ visibleHeight }px`).removeClass('is_open')
				$(showMoreBtn, showMoreNav).removeClass('is_open')
				$(showMoreBtnTxt, showMoreNav).text(firstTxt)
			}
		})
	})
})
